module.exports = __webpack_public_path__ + "static/media/newFounderItems.1ebf5b46.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/newFounderItems.svg
// module id = 841
// module chunks = 0